import React from "react";
import { useState, useEffect, useRef } from "react";
import LoadingBar from "react-top-loading-bar";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MergePDFMergerListScreen from "./MergePDFMergerListScreen";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function MergePDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Merge PDF files" };
  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/merge_pdf", title: "PDF Merger" },
    data2: { link: "/merge_pdf", title: "Combine multiple PDFs" },
    data3: { link: "/merge_pdf", title: "Join PDFs" },
  };

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Merge PDF files online easily. Combine multiple PDFs into one document quickly using our fast, secure, and user-friendly PDF merger tool."
      ></meta>
      <meta
        name="keywords"
        content="pdf merger, merge pdf, combine pdf files, merge pdf online, pdf combiner, join pdf files, online pdf merger, merge multiple pdfs, pdf merge tool, combine pdf online, pdf editor online, pdf management tool, merge pdf free, pdf file merger, join pdf documents"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <MergePDFMergerListScreen title={title}></MergePDFMergerListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Offline Merge PDF Tool is a powerful and secure solution designed for users who want to merge PDF files offline without relying on an internet connection, making it ideal for professionals, businesses, and individuals who need complete privacy and control over their documents. This advanced PDF merger software allows you to combine multiple PDF files into one document, arrange pages in the desired order, and seamlessly merge large PDF files while preserving original formatting, layout, fonts, and image quality. Unlike online tools, this offline PDF merge tool processes all files directly on your device, ensuring sensitive data remains private and protected, which is essential for handling legal documents, financial reports, contracts, and confidential files. With fast performance and intelligent processing, the tool supports batch merging, unlimited file sizes, and smooth operation on Windows, macOS, and other desktop platforms. Whether you need to merge PDFs for work, create a single file from multiple reports, or organize scanned documents efficiently, this best offline PDF merger provides a user-friendly interface, high-speed processing, and reliable results, making it the perfect secure PDF merge solution for offline PDF management." />
          {/* How to use define max 4 steps */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Merge",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="PDF Merger"
            why_use={[
              {
                title: "Combine Multiple PDF Files Easily",
                description:
                  "Merge several PDF documents into one organized file, making it easier to store, view, and manage.",
              },
              {
                title: "Simplify Document Sharing",
                description:
                  "Share a single merged PDF instead of sending multiple attachments, reducing confusion and improving convenience.",
              },
              {
                title: "Privacy & Protect",
                description:
                  "You documents are protected through our high level encryption and deleted immediately after compression.",
              },

              {
                title: "Improve Workflow Efficiency",
                description:
                  "A fast and easy-to-use PDF merger tool helps students and professionals work more efficiently by keeping everything in one place.",
              },
              {
                title: "Stay Organized and Reduce Clutter",
                description:
                  "Merge invoices, reports, receipts, and scanned pages to keep your digital workspace clean and structured.",
              },
              {
                title: "Quick & Easy",
                description:
                  "Save your time as this app is quick and easy to use, just select file and convert it.",
              },
              {
                title: "Free to use",
                description:
                  "You don't need any account or sign up to start using our service. Very little time required to get your jobs done and the great part is it is free to use. And our app works completely offline.",
              },
              {
                title: "Bulk Conversion",
                description:
                  "Combine multiple pdf files at once and save time using the premium version of this app.",
              },
              {
                title: "Save Storage Space",
                description:
                  "Use a PDF merge and compress tool to optimize file size while keeping everything neatly consolidated.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How can I merge PDF files online for free?",
                description:
                  "You can merge PDF files by selecting two or more documents, arranging them in your preferred order, and combining them into a single PDF. Once processing is complete, download the merged document."
              },
              {
                title: "What is a PDF merger?",
                description:
                  "A PDF merger is a tool that combines multiple PDF documents into one file. It is useful for joining reports, invoices, scanned documents, assignments, contracts, and other PDF files."
              },
              {
                title: "Can I merge PDF files offline?",
                description:
                  "Yes, if the PDF merger supports offline processing. A browser-based tool that processes files locally can combine PDF documents on your device after the website and required resources have loaded."
              },
              {
                title: "Does ShivaPDF merge PDF files locally in my browser?",
                description:
                  "Local PDF processing means documents are combined directly in your browser rather than uploaded to a remote server. Check that the Merge PDF tool on ShivaPDF.com supports local processing before using it for confidential documents."
              },
              {
                title: "Can I merge PDFs without uploading files?",
                description:
                  "Yes, when the PDF merger performs all processing locally in your browser. In that case, your documents can remain on your device instead of being sent to a server. Verify that the tool supports local processing before selecting sensitive files."
              },
              {
                title: "Is it safe to merge PDF files online?",
                description:
                  "Choose a PDF merger that clearly explains how it handles your files. For confidential documents, a tool that processes PDFs locally without uploading them can help reduce exposure of your information."
              },
              {
                title: "How many PDF files can I merge at once?",
                description:
                  "The number of PDFs you can merge depends on the tool's limits, document sizes, and your device's available memory. For large documents, merging smaller groups of files may improve performance."
              },
              {
                title: "Can I merge multiple PDF files into one document?",
                description:
                  "Yes, a PDF merger combines multiple documents into a single PDF file. This helps organize related documents into one file that is easier to share, store, and manage."
              },
              {
                title: "Can I choose the order of PDF files before merging?",
                description:
                  "If the tool supports reordering, you can arrange your PDF files before merging them. Review the order carefully to ensure that the final document follows your intended sequence."
              },
              {
                title: "Can I rearrange PDF pages before merging?",
                description:
                  "Some PDF merging tools allow you to rearrange pages or documents before combining them. Check the available controls to see whether page-level reordering is supported."
              },
              {
                title: "Can I merge PDF files with different page sizes?",
                description:
                  "PDF documents with different page sizes can generally be combined into one PDF. The pages usually retain their individual dimensions unless the tool provides options to resize or standardize them."
              },
              {
                title: "Will merging PDF files reduce their quality?",
                description:
                  "Merging PDFs should generally preserve the original page content, text, and images when the files are combined without additional compression or conversion. Always review the output to confirm that it meets your requirements."
              },
              {
                title: "Can I merge scanned PDF documents?",
                description:
                  "Yes, scanned documents saved as PDFs can usually be merged like other PDF files. Their pages remain images within the resulting document unless optical character recognition (OCR) is applied separately."
              },
              {
                title: "Can I merge password-protected PDF files?",
                description:
                  "Some password-protected PDFs require you to enter the correct password before they can be merged. Support depends on the document's security settings and the PDF merging tool."
              },
              {
                title: "Can I merge PDF files on my mobile phone?",
                description:
                  "You can merge PDFs on an Android phone, iPhone, or tablet using a compatible browser-based tool. Performance depends on document size, browser support, and available device memory."
              },
              {
                title: "Can I merge PDF files on Windows and Mac?",
                description:
                  "Yes, you can use a compatible browser-based PDF merger on Windows and macOS. If the tool supports local processing, documents can be merged directly in the browser without installing separate software."
              },
              {
                title: "Do I need to install software to merge PDFs?",
                description:
                  "A browser-based PDF merger can let you combine documents without installing a desktop application. Internet access may still be required to load the website, depending on its offline capabilities."
              },
              {
                title: "Can I merge PDF files without creating an account?",
                description:
                  "Account requirements depend on the service. Check the Merge PDF page on ShivaPDF.com to confirm whether you can combine documents without registering or signing in."
              },
              {
                title: "Will merging PDFs change the original files?",
                description:
                  "Merging normally creates a new combined PDF and leaves the original documents unchanged. Keep your original files until you have checked that the merged document contains all the required pages."
              },
              {
                title: "Can I merge PDF files containing images and text?",
                description:
                  "Yes, PDF documents containing text, images, graphics, or a mixture of content can generally be combined into one file. The resulting document depends on the content and compatibility of the original PDFs."
              },
              {
                title: "Why is merging PDF files taking so long?",
                description:
                  "Large PDFs, image-heavy documents, and files containing many pages can take longer to process. Try merging fewer files at a time, closing unnecessary browser tabs, or using a device with more available memory."
              },
              {
                title: "Why can't I download my merged PDF?",
                description:
                  "Make sure the merging process has finished and your browser allows downloads. If the download fails, try again, check your available storage, and confirm that the browser supports the tool."
              },
              {
                title: "Is the Merge PDF tool on ShivaPDF free?",
                description:
                  "Visit the Merge PDF page on ShivaPDF.com to check current availability, file-size limits, and any usage restrictions. Features and limits depend on the tool's current implementation."
              }
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1624184310}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default MergePDFMain;
